export default __webpack_public_path__ + "static/lilardia-logo-e99f878ee995991633bfdde3ef88ed84.png";